Namespace 'Customer.Ticket'

class Customer.Ticket.SurveyEndingView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/survey_ending']
  className: 'survey-notice'

  initialize: ({datetime}) ->
    @datetime = datetime

  render: ->
    @$el.html @template
      datetime: @datetime
    @
